// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import constants from "@store/constants";
import { useBlogHomeDataView } from "@store/Framework/Store/Data/BlogHome/BlogHomeHooks";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { loadPagesForParent } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";
import * as React from "react";
import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

const BlogHomePage: FC<PageProps> = ({ id }) => {
    const dispatch = useDispatch();
    const currentPage = useCurrentPage();
    const blogHomeDataView = useBlogHomeDataView();
    const { isLoading, value } = blogHomeDataView;

    useEffect(() => {
        if (!isLoading && !value) {
            dispatch(loadPagesForParent({ parentNodeId: currentPage.nodeId }));
        }
    }, []);

    return (
        <MobiusPage>
            <Zone contentId={id} zoneName="Content" />
        </MobiusPage>
    );
};

const pageModule: PageModule = {
    component: BlogHomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        allowedChildren: [constants.pageType.blogCategoryPage],
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
